import React from 'react';
import { useSelector } from 'react-redux';
import {
    selectComputers,
    selectOfficeObj
} from '../../redux/slices/office-slice.js';
import CopyComputerInfo from './CopyComputerInfo.jsx';
import convertPhoneNumberToNationalFormat from '../../utils/convert-phone-number-to-national.js';

/**
 * Component for displaying office information.
 *
 * @returns {JSX.Element} JSX element representing the Office Information.
 */
const CopyOfficeInfo = () => {
    const computers = useSelector(selectComputers);
    const officeObj = useSelector(selectOfficeObj);

    let kocDate = null;

    if (officeObj.kocDate) {
        const thisKoc = new Date(officeObj.kocDate);
        const year = thisKoc.getFullYear();
        const month = thisKoc.getMonth() + 1;
        const day = thisKoc.getDate();

        kocDate = `${month}/${day}/${year}`;
    }

    return (
        <div style={{ marginLeft: '30px' }}>
            <p>
                Number of separate connections &nbsp;
                {officeObj.numOfDBConnections > 0 &&
                    `DB: ${officeObj.numOfDBConnections} `}
                {officeObj.numOfIVConnections > 0 &&
                    `IV: ${officeObj.numOfIVConnections} `}
                {officeObj.numOfPPConnections > 0 &&
                    `PB: ${officeObj.numOfPPConnections}`}
                {/* FS:{' '}
                {officeObj.numOfFSConnections} */}
            </p>
            <p>SC Connection Type: {officeObj.connectionSoftware}</p>
            {/* Computers - only if at least one credential exists */}
            {computers.map((computer) => {
                if (!computer.isITOnly && computer.credentials?.length > 0) {
                    return (
                        <CopyComputerInfo
                            key={computer._id}
                            systematicName={computer.computerSysName}
                            OS={computer.OS}
                            location={computer.location}
                            credentials={computer.credentials}
                            isAvInstalled={computer.avInstalled}
                            avName={computer.avName}
                        />
                    );
                }
                return null;
            })}
            <p className="copy-and-paste-text">EOB Path: {officeObj.eobPath}</p>
            <div style={{ marginBottom: '1em' }}>
                <p className="copy-and-paste-text">
                    PMS Software: {officeObj.dentalSoftware}
                </p>
                {officeObj.connectionSoftware?.toLowerCase() === 'cloud' &&
                    officeObj.dsURL && (
                        <p className="copy-and-paste-text">
                            Cloud PMS URL: {officeObj.dsURL}
                        </p>
                    )}
                <p className="copy-and-paste-text">
                    eClaims Program: {officeObj.eClaims}
                </p>
                <p className="copy-and-paste-text">
                    Is eClaims properly functioning?
                </p>
                <p className="copy-and-paste-text">
                    eAttachment Program: {officeObj.attachments}
                </p>
                <p className="copy-and-paste-text">
                    X-Rays Program: {officeObj.xrays}
                </p>
            </div>
            {/* <p className="copy-and-paste-text">
                Is the X-Rays program functioning properly?
            </p> */}
            <div style={{ marginBottom: '1em' }}>
                <p className="copy-and-paste-text">
                    PDF Printer: {officeObj.pdfPrinter}
                </p>
                <p className="copy-and-paste-text">
                    Scanner Info: {officeObj.scannerInfo}
                </p>
                <p className="copy-and-paste-text">
                    What time do backups occur?: {officeObj.backupTimes}
                </p>
                {/* <p style={{ marginTop: '0em' }}>
                Firewall Info: {officeObj.firewallInfo}
            </p> */}
                <p className="copy-and-paste-text">
                    Zilla Number:{' '}
                    {officeObj.twilioActivated
                        ? convertPhoneNumberToNationalFormat(
                              officeObj.twilioNumber
                          )
                        : 'N/A'}
                </p>
                <p className="copy-and-paste-text">
                    Caller ID Verified:{' '}
                    {officeObj.callerIdVerified ? 'Yes' : 'No'}
                </p>
                <p className="copy-and-paste-text">
                    Zilla Business Profile status:{' '}
                    {officeObj.businessProfile?.status}
                </p>
            </div>
            {officeObj.connectionSoftware === 'Cloud' && (
                <p className="copy-and-paste-text">Is sharefile set up?</p>
            )}
            {officeObj.kocDate ? (
                <p className="copy-and-paste-text">
                    Date Authorized for KOC: {kocDate}
                </p>
            ) : (
                <p className="copy-and-paste-text">
                    Office is not authorized for KOC
                </p>
            )}
        </div>
    );
};

export default CopyOfficeInfo;
